export default {
  LazadaTrusteeship: "Lazada托管",
  Offline_stores: "线下店铺",

  If_You_Need_To_Select_All_Stores_Under_A_Platform_Simply_Check_The_Platform_Itself:
    "如果需要选择某平台下的所有店铺，只需要勾选该平台即可",
  If_Both_A_Platform_And_Its_Stores_Are_Selected_The_Filter_Result_Will_Be_Based_On_The_Selected_Stores:
    "如果既选择了平台又选择了该平台下的店铺，那么筛选结果以选择的店铺为准",
  If_You_Need_To_Clear_The_Selected_Stores_Under_A_Platform_Click_The_Clear_Button_On_The_Right_Side_Of_The_Platform:
    "如果需要清空该平台已选择店铺，可以点击平台右侧的清空按钮",
  Selections_Across_Different_Platforms_Are_Independent_Of_Each_Other:
    "各平台之间的选择相互独立",

  Last_Three_Months: "最近三个月",

  Not_Acquired: "未获取",
  Not_Online: "未上网",
  Delivered: "已交付",

  Pending_Sorting: "待分拣",
  Sorting_In_Progress: "分拣中",
  Sorting_Completed: "已完成分拣",
  Sorting_Exception: "分拣异常",
  Cancellation_Exception: "撤销异常",
  Void_Exception: "取消异常",

  Number_Of_Items_Displayed_Per_Column: "一列显示个数",
  The_Default_Number_Of_Items_Displayed_In_The_Table_Header_Per_Column_Is_1_And_Can_Be_Set_From_1_To_5:
    "表头一列显示个数，默认为1，可设置1-5",
  Restore_Default_Style: "恢复默认风格",
  Click_To_Use_The_Initial_Default_Style: "点击可使用初始默认风格；",
  Add_New_Style: "新增风格",
  Click_To_Add_A_New_Style_Enter_The_Style_Name_And_Press_Enter_Or_Click_Outside_The_Input_Box_To_Save:
    "点击可新增风格，输入风格名称后回车或点击输入框外区域即可保存；",
  Modify_Style: "修改风格",
  After_Modifying_A_Style_It_Must_Be_Re_Saved_To_Take_Effect:
    "对风格进行修改后，须重新保存，才可生效；",
  Fields_Can_Be_Sorted_By_Dragging_And_Width_Can_Be_Set_If_The_Width_Of_Fields_Displayed_In_A_Column_Is_Different_The_Maximum_Width_Is_Taken_By_Default:
    "可拖拽字段进行排序，可对宽度进行设置，若一列显示字段的宽度不同，则默认取最大宽度。",
  Customize_List_Fields: "自定义列表字段",

  This_Operation_Will_Permanently_Delete_This_Saved_Item_Proceed:
    "此操作将永久删除该保存, 是否继续?",
  This_Operation_Will_Be_Permanent_Proceed: "此操作将永久删除, 是否继续?",

  Signed: "已签署",
  Return_To_Home: "返回首页",

  Please_Enter_The_Article_Name_Here_And_Press_Enter_To_Search:
    "请在这里输入文章名称后回车搜索",
  Updated_On: "更新于",
  Published_On: "发布于",
  Previous_Page: "上一页",
  Next_Page: "下一页",
  No_Documents_Available: "暂无文档",
  Document_Update_Time: "文档更新时间",

  Receive_Message_Push_Notifications: "是否接收消息推送",
  Add_Binding: "添加绑定",
  The_Current_Push_Mechanism_Uses_Scheduled_Tasks_After_Editing_Personal_Information_The_Push_Will_Not_Take_Effect_Immediately_Please_Wait_Patiently:
    "当前推送机制通过定时任务进行推送，编辑完个人信息后，推送不会立即生效，请耐心等待。",
  For_More_Information_Please_Refer_To_The_Instructions:
    "若需了解更多信息，请查看说明。",
  Modify_WeChat_Binding_User: "修改微信绑定用户",
  WeChat_Binding_User: "微信绑定用户",
  WeChat_Binding_ID: "微信绑定id",
  WeChat_Binding_Status: "微信绑定状态",
  WeChat_OpenID: "微信OpenID",
  WeChat_Binding_Time: "微信绑定时间",
  WeChat_Official_Account_Binding_Time_By_Scan: "通过扫码绑定微信公众号时间",
  WeChat_Unbinding_Time: "微信解绑时间",
  Record_The_Time_After_Unbinding: "记录解绑后的时间",
  Select_Sub_Account: "选择子账号",

  Close_Right: "关闭右侧",
  Close_Left: "关闭左侧",
  Close_Others: "关闭其它",
  Refresh_Page: "刷新页面",
  This_Is_The_Last_Page_It_Cannot_Be_Closed_Anymore:
    "这是最后一页, 不能再关闭了",

  Balance_Alert: "余额预警",
  Orders_Pending_Processing: "订单待处理",

  Contract_Not_Yet_Generated: "暂未生成合同",

  The_Product_Cargo_Attribute_Is_Only_Used_For_The_Product_Cargo_Attribute_In_First_Mile_Logistics:
    "商品货物属性只用于头程物流的商品货物属性",

  Please_Select_A_Platform_First: "请先选择平台",
  Please_Enter_The_Recipient_Name_To_Search: "请输入收件人名称进行查询",
  Please_Go_To: "请到",
  To_Add_Or_Edit_Recipient_Information: "添加/编辑收件人信息",
  Up_To_5000_Product_Details_Are_Supported_If_Exceeded_Please_Use_The_Table_Import_Function:
    "最多支持5000条商品明细，若超过，请使用表格导入功能。",
  Please_Fill_In_The_Cargo_List_Truthfully_And_Declare_Accurately_If_Any_Losses_Or_Legal_Liabilities_Arise_Due_To_Untruthful_Declaration_The_Sender_Shall_Bear_All_Consequences:
    "货物清单请如实填写，如实申报，若因未如实申报导致一切损失及法律责任将由寄件方自行承担。",
  Add_Number_Of_Cartons: "添加箱数",
  Maximum_Of_100_Cartons_Can_Be_Added_At_A_Time: "单次最大支持新增100箱",
  Batch_Add_Number_Of_Cartons: "批量添加箱数",
  Add_Product: "添加商品",
  Enter_SKU_Or_Product_Barcode_To_Quickly_Add_Products_For_Batch_Addition_Please_Use_Commas_Or_Line_Breaks_To_Separate_You_Can_Drag_The_Text_Box_Itself:
    "输入sku或商品条码，可快速添加商品，批量添加请使用逗号或换行隔开，可自行拖拽文本框。",
  Please_Enter_A_Positive_Number_Greater_Than_0: "请输入大于0的正数",
  For_The_Same_Carton_Specifications_And_Products_You_Can_Directly_Enter_The_Number_Of_Cartons_After_Saving_The_System_Will_Automatically_Generate_The_Corresponding_Number_Of_Cartons:
    "同样箱规及商品可直接输入箱数，保存后系统会自动生成对应箱数。",
  Clear_Products: "清空商品",
  The_Current_Number_Of_Product_Details_Is: "当前商品明细数量为",
  Please_Use_The_Table_Import_Function_To_Proceed:
    "请使用表格导入功能进行操作。",
  Please_Enter_SKU_Or_Product_Barcode: "请输入sku或商品条码",
  If_Warehouse_Selection_Is_Required_On_The_Page_Products_Can_Only_Be_Selected_After_Selecting_A_Warehouse:
    "若页面内需选择仓库，选择仓库后才能进行商品选择。",
  If_A_Warehouse_Is_Selected_Only_Products_With_Stock_Shelved_In_That_Warehouse_Will_Be_Displayed:
    "如果选择了仓库，那么仅展示有上架过库存的商品。",

  Replenishment: "补货",
  Lazada_Third_Party_Warehouse_Transfer: "Lazada三方仓调拨",
  Pending: "待处理",
  Manual_Outbound_Order: "手工出库单",
  Manual_Inbound_Order: "手工入库单",
  Transfer_Outbound_Order: "调拨出库单",
  Transfer_Inbound_Order: "调拨入库单",
  Inventory_Count_Loss: "盘点盘亏",
  Inventory_Count_Surplus: "盘点盘盈",
  Return_Stock_Move_To_Shelf: "退货库存移库上架",
  Return_Location_Return_To_Pending_Review_Status: "退货库位退回待审核状态",
  Transfer_To_Unavailable_Inventory: "转入不可用库存",
  Transfer_To_Available_Inventory: "转入可用库存",
  Unavailable_Inventory_Shelving: "不可用库存上架",
  Replenishment_Picking: "补货下架",
  Replenishment_Picking_Split_Picking: "补货下架分割下架",
  Replenishment_Picking_Split_Shelving: "补货下架分割上架",
  Replenishment_Shelving: "补货上架",

  This_File_Is_For_Warehouse_Process_Reference: "此文件用于给仓库做流程参考",
  Please_Enter_The_Transfer_Customer_ID: "请输入转移客户ID",

  Application_In_Progress: "申请中",
  Invoiced: "已开票",

  Interface_Communication_Failed_Please_Try_Refreshing_The_Page_Or_Logging_In_Again:
    "接口通讯失败，请尝试刷新页面或者重新登录。",
  If_The_Problem_Persists_Please_Contact_The_Administrator:
    "如果还是存在问题，请联系管理员。",
  Required_Fields_Are_Incomplete_Communication_Failed:
    "存在未填写的必填项，通讯失败。",

  Export_Excel_Task: "导出Execl任务",
  Outbound_Video_Task: "出库录像任务",
  First_Mile: "头程",
  Inbound: "入库",
  Export_PDF: "导出PDF",
  Order_Profit_Recalculation: "订单利润重算",
  Bulk_Data_Export: "大批量数据导出",

  Please_Upload_A_PDF_File: "请上传PDF文件",
  The_File_Size_Cannot_Exceed_10MB: "文件大小不能超过10M",

  Other: "其它",
  Exception_Order_Notification: "异常订单通知",

  Not_Generated: "未生成",
  Pending_Processing: "待处理",
  Pending_Collection: "待收款",
  Financial_Verification: "财务核实",
  Collection_Confirmed: "核实收款",

  Last_Mile_Receiving_In_Progress: "尾程收货中",
  Quality_Inspection_In_Progress: "质检中",
  Shelving_In_Progress: "上架中",

  Return_Item: "退件",
  Manual_Outbound: "手工出库",
  Manual_Inbound: "手工入库",
  Inventory_Loss: "盘亏",
  Inventory_Surplus: "盘盈",
  Inventory_Order: "入库单",

  Inbound_Equals_First_Inbound_Shelving: "入库等于首次入库上架",
  Return_Item_Equals_First_Return_Item_Shelving: "退件等于首次退件上架",
  Order_Equals_First_Order_Outbound: "订单等于首次订单出库",
  Registration_Equals_Customer_Registration_Time: "注册等于客户的注册时间",
  Approval_Passed_Equals_The_Time_When_The_Customer_Account_Was_First_Approved:
    "审核通过等于客户账号首次审核通过时间",
  Billing_Equals_The_Time_Of_The_First_Deduction_Billing_Excluding_Recharge_Refund_And_Other_Credit_Entries:
    "出账等于第一次扣费出账的时间，不包括充值，退款等等入账记录",

  Within_The_Filtered_Time_Period_The_Sales_Quantity_Of_This_SKU_In_This_Store:
    "筛选时间内，该SKU在该店铺的销售数量",
  Within_The_Filtered_Time_Period_The_Sales_Quantity_Of_Products_In_This_Warehouse:
    "筛选时间内，该仓库的商品销售数量",
  Within_The_Filtered_Time_Period_The_Sales_Quantity_Of_Products_On_This_Platform:
    "筛选时间内，该平台的商品销售数量",
  Within_The_Filtered_Time_Period_The_Sales_Quantity_Of_Products_In_This_Country:
    "筛选时间内，该国家的商品销售数量",
  Within_The_Filtered_Time_Period_The_Sales_Quantity_Of_Products_In_This_Store:
    "筛选时间内，该店铺的商品销售数量",

  Total_Duration_Of_Overdue_Payments: "逾期总时长",
  Initial_Workpiece_Follow_Up_Workpiece: "首件/续件",
  True_Weight: "真实重量",
  The_Total_Order_Volume_Of_Newly_Developed_Customers: "新开发客户总单量",
  T_N: "T-N",

  Priority_of_listing_scanning: "上架扫描优先级",

  // 新开发客户设置相关
  Is_entire_month: "是否满月计算",
  Update_person: "更新人",

  Picking: "配货",
  Sorting: "分拣",
  Shipping: "发货",
  Revocation_Exception: "撤销异常",
};
